<script setup>
import { useStore } from 'vuex';
import { __x } from 'JIX/gettext';
import DsSmallTip from 'JIX/components/ds/DsSmallTip.vue';
import DsLinkBlock from 'JIX/components/ds/DsLinkBlock.vue';

defineProps({
    suggestion: {
        type: Object,
        required: true,
    },
});

const store = useStore();

function handleSelectSuggestion(params) {
    store.commit('setSearchQuery', params);
    return store.dispatch('performSearch');
}

</script>

<template>
    <DsSmallTip
        :heading-tag="'Tip'"
        :heading="__x('Mente du {suggestion}?', { suggestion: suggestion.suggestion })"
        dismissable
    >
        <DsLinkBlock
            class="mt-1"
            :href="suggestion.suggestionUrl"
            @click.prevent="handleSelectSuggestion(suggestion.suggestionParams)"
        >
            {{ __x('Skift til {suggestion}', { suggestion: suggestion.suggestion }) }}
        </DsLinkBlock>
    </DsSmallTip>
</template>
